"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATCGroupHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const atc_group_header_style_1 = __importDefault(require("./atc.group.header.style"));
const avatar_group_1 = __importDefault(require("../avatar/avatar.group"));
class ATCGroupHeader extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, avatarSrc, text, onClick, loading, disabled } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "aria-busy": loading, "data-cy": "atomic-atc-group-header" }, { children: jsx_runtime_1.jsxs("button", Object.assign({ className: classes.button, type: "button", disabled: disabled || loading, onClick: onClick }, { children: [avatarSrc && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.avatar }, { children: jsx_runtime_1.jsx(avatar_group_1.default, { src: avatarSrc, size: 24 }, void 0) }), void 0)),
                        jsx_runtime_1.jsx("div", Object.assign({ className: classes.name }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.truncate }, { children: text }), void 0) }), void 0)] }), void 0) }), void 0));
        };
    }
}
exports.ATCGroupHeader = ATCGroupHeader;
ATCGroupHeader.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    avatarSrc: prop_types_1.default.string,
    text: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    disabled: prop_types_1.default.bool,
    loading: prop_types_1.default.bool
};
ATCGroupHeader.defaultProps = {
    avatarSrc: null,
    loading: false,
    disabled: false
};
exports.default = react_jss_1.default(atc_group_header_style_1.default)(ATCGroupHeader);
//# sourceMappingURL=atc.group.header.js.map